(function () {
  var storageKey = 'mairaz_instagram_visitor';

  function isInstagramHost(hostname) {
    var host = String(hostname || '').toLowerCase().replace(/^www\./, '');
    return host === 'instagram.com' || host.endsWith('.instagram.com');
  }

  function hasInstagramUtm() {
    try {
      return new URLSearchParams(window.location.search).get('utm_source')?.toLowerCase() === 'instagram';
    } catch (error) {
      return false;
    }
  }

  function hasInstagramReferrer() {
    if (!document.referrer) return false;
    try {
      return isInstagramHost(new URL(document.referrer).hostname);
    } catch (error) {
      return false;
    }
  }

  try {
    if (hasInstagramUtm() || hasInstagramReferrer()) {
      sessionStorage.setItem(storageKey, '1');
      sessionStorage.setItem('mairaz_instagram_landing', window.location.href);
    }

    if (sessionStorage.getItem(storageKey) === '1') {
      document.documentElement.classList.add('mrz-instagram-visitor');
      window.MairazInstagramVisitor = true;
      document.dispatchEvent(new CustomEvent('mairaz:instagram-visitor'));
    }
  } catch (error) {
    window.MairazInstagramVisitor = hasInstagramUtm() || hasInstagramReferrer();
    if (window.MairazInstagramVisitor) document.documentElement.classList.add('mrz-instagram-visitor');
  }
})();


(function () {
  if (window.location.pathname !== '/collections/shop-instagram') return;

  var scrollKey = 'mairaz_shop_instagram_scroll_v1';

  function normalizedPageKey() {
    var url = new URL(window.location.href);
    url.searchParams.sort();
    return url.pathname + (url.search ? url.search : '');
  }

  function saveProductGridPosition(event) {
    var link = event.target.closest && event.target.closest('a[href]');
    if (!link) return;

    try {
      var destination = new URL(link.href, window.location.origin);
      if (destination.origin !== window.location.origin || !destination.pathname.startsWith('/products/')) return;

      var savedState = {
        page: normalizedPageKey(),
        y: Math.max(0, Math.round(window.scrollY)),
        productPath: destination.pathname,
        offset: Math.round(link.getBoundingClientRect().top),
        savedAt: Date.now()
      };

      sessionStorage.setItem(scrollKey, JSON.stringify(savedState));
      var nextHistoryState = Object.assign({}, history.state || {});
      nextHistoryState.mrzShopInstagramScroll = savedState;
      history.replaceState(nextHistoryState, '', window.location.href);
    } catch (error) {
      return;
    }
  }

  function restoreProductGridPosition() {
    var saved = history.state && history.state.mrzShopInstagramScroll;

    if (!saved) {
      try {
        saved = JSON.parse(sessionStorage.getItem(scrollKey) || 'null');
      } catch (error) {
        sessionStorage.removeItem(scrollKey);
        return;
      }
    }

    if (!saved || saved.page !== normalizedPageKey() || Date.now() - Number(saved.savedAt || 0) > 600000) return;

    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

    [0, 250, 700, 1400, 2600].forEach(function (delay, index, delays) {
      window.setTimeout(function () {
        var matchingLinks = Array.prototype.slice.call(document.querySelectorAll('a[href]'));
        var target = matchingLinks.find(function (link) {
          try {
            return new URL(link.href, window.location.origin).pathname === saved.productPath && link.getClientRects().length;
          } catch (error) {
            return false;
          }
        });

        if (target) {
          var targetOffset = target.getBoundingClientRect().top;
          window.scrollBy(0, targetOffset - Number(saved.offset || 0));
        } else {
          window.scrollTo(0, Number(saved.y) || 0);
        }

        if (index === delays.length - 1) {
          sessionStorage.removeItem(scrollKey);
          var clearedState = Object.assign({}, history.state || {});
          delete clearedState.mrzShopInstagramScroll;
          history.replaceState(clearedState, '', window.location.href);
        }
      }, delay);
    });
  }

  function saveCurrentCollectionPosition() {
    var productLinks = Array.prototype.slice.call(document.querySelectorAll('a[href*="/products/"]')).filter(function (link) {
      return link.getClientRects().length;
    });
    var target = productLinks.reduce(function (closest, link) {
      var distance = Math.abs(link.getBoundingClientRect().top - window.innerHeight / 2);
      if (!closest || distance < closest.distance) return { link: link, distance: distance };
      return closest;
    }, null);

    var targetLink = target && target.link;
    var savedState = {
      page: normalizedPageKey(),
      y: Math.max(0, Math.round(window.scrollY)),
      productPath: targetLink ? new URL(targetLink.href, window.location.origin).pathname : '',
      offset: targetLink ? Math.round(targetLink.getBoundingClientRect().top) : 0,
      savedAt: Date.now()
    };

    try {
      sessionStorage.setItem(scrollKey, JSON.stringify(savedState));
      var nextHistoryState = Object.assign({}, history.state || {});
      nextHistoryState.mrzShopInstagramScroll = savedState;
      history.replaceState(nextHistoryState, '', window.location.href);
    } catch (error) {
      return;
    }
  }

  document.addEventListener('click', saveProductGridPosition, true);
  window.addEventListener('pagehide', saveCurrentCollectionPosition);
  window.addEventListener('pageshow', restoreProductGridPosition);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restoreProductGridPosition, { once: true });
  } else {
    restoreProductGridPosition();
  }
})();
